const translations = {
  "en": {
    "Access to Edgen Report": "Access to Ed Report",
    "Become an Expert member to unlock premium trading signals.": "Become an Expert member to unlock premium trading signals.",
    "Check Details": "Check Details",
    "Contact Us": "Contact Us",
    "Contact us for an Expert plan.": "Contact us for an Expert plan.",
    "Contact us for Upgrade": "Contact us for Upgrade",
    "Contact us to upgrade your plan": "Contact us to upgrade your plan",
    "Earn More Aura Rewards": "Earn More Points Rewards",
    "Extra Aura": "Extra Points",
    "Increased Search": "Increased Search",
    "Limits Are Boring. Go Expert.": "Limits Are Boring. Go Expert.",
    "Monthly Edgen Report limit reached": "Monthly Ed Report limit reached",
    "More Searches": "More Searches",
    "Powerful Trading Tools": "Powerful Trading Tools",
    "Start $1 Trial": "Start $1 Trial",
    "Upgrade": "Upgrade",
    "Upgrade to Get Real-Time Results.": "Upgrade to Get Real-Time Results.",
    "You can still dive deeper into all the details about tokens and stocks!": "You can still dive deeper into all the details about tokens and stocks!"
  },
  "zh-tw": {
    "Access to Edgen Report": "訪問 Ed 報告",
    "Become an Expert member to unlock premium trading signals.": "成為 Expert 會員，解鎖進階交易訊號。",
    "Check Details": "查看詳情",
    "Contact Us": "聯絡我們",
    "Contact us for an Expert plan.": "聯絡我們以獲取 Expert 方案。",
    "Contact us for Upgrade": "聯絡我們以進行升級",
    "Contact us to upgrade your plan": "請聯絡我們以升級你的方案",
    "Earn More Aura Rewards": "賺取更多 Points 獎勵",
    "Extra Aura": "額外 Points",
    "Increased Search": "增加搜尋次數",
    "Limits Are Boring. Go Expert.": "上限很無聊，升級 Expert 吧。",
    "Monthly Edgen Report limit reached": "已達每月 Ed 報告上限",
    "More Searches": "更多搜尋",
    "Powerful Trading Tools": "強大的交易工具",
    "Start $1 Trial": "開始 1 美元試用",
    "Upgrade": "升級",
    "Upgrade to Get Real-Time Results.": "立即升級，取得即時結果。",
    "You can still dive deeper into all the details about tokens and stocks!": "你還可以深入探索有關代幣和股票的所有細節！"
  }
};

export default translations;
